/**
 * Dashboard cinematic pack (`public/assets/dashboard/`).
 */
export function dashboardAsset(fileName) {
  const base = typeof process.env.PUBLIC_URL === "string" ? process.env.PUBLIC_URL : "";
  return `${base}/assets/dashboard/${fileName}`;
}
